import { Card, CardBody } from "@/components/Card";

const PendingReportCardSkeleton = () => (
  <Card
    className="cle-afventende-indberetninger-card cle-afventende-indberetninger-card--compact border border-white"
    aria-hidden="true"
  >
    <CardBody className="cle-afventende-indberetninger-card__inner flex-column d-flex gap-2 p-0 relative">
      <div
        className="position-absolute top-0 start-0 cle-bg-destructive"
        style={{
          width: "6px",
          height: "100%",
          borderRadius: "0.5rem 0 0 0.5rem",
        }}
      />
      <div className="placeholder-glow d-flex flex-column gap-2">
        <div className="cle-afventende-indberetninger-card__header-row d-flex flex-wrap align-items-start justify-content-between gap-2">
          <div className="min-w-0">
            <span
              className="placeholder rounded d-block mb-1"
              style={{ height: "0.75rem", width: "7rem" }}
            />
            <span
              className="placeholder rounded d-block"
              style={{ height: "1rem", width: "11rem" }}
            />
          </div>
          <span
            className="placeholder rounded-3 flex-shrink-0"
            style={{ height: "1.75rem", width: "5.5rem" }}
          />
        </div>

        <div
          className=" d-flex align-items-center gap-2 rounded"
          style={{ minHeight: "2.25rem" }}
        >
          <span
            className="placeholder rounded flex-grow-1"
            style={{ height: "0.875rem", maxWidth: "28rem" }}
          />
        </div>

        <div className="d-flex flex-wrap align-items-center gap-2">
          <div className="d-flex gap-2 align-items-center">
            <span
              className="placeholder rounded flex-shrink-0"
              style={{ height: "1.0625rem", width: "1.0625rem" }}
            />
            <span
              className="placeholder rounded"
              style={{ height: "0.875rem", width: "10.5rem" }}
            />
          </div>

          <div className="d-flex gap-2 align-items-center">
            <span
              className="placeholder rounded flex-shrink-0"
              style={{ height: "1.0625rem", width: "1.0625rem" }}
            />
            <span
              className="placeholder rounded"
              style={{ height: "0.875rem", width: "9.5rem" }}
            />
          </div>
        </div>
      </div>
    </CardBody>
  </Card>
);

export default PendingReportCardSkeleton;
